module.exports = __webpack_public_path__ + "img/02f9202.jpg";